<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import ProductsTable from '@components/retina/products/productsTable'
import { productsMethods } from '@state/helpers'

export default {
  name: 'products',
  page: {
    title: 'Productos',
    meta: [{ name: 'Existing products', content: 'Existing products' }],
  },
  components: { Layout, PageHeader, ProductsTable },
  data() {
    return {
      title: '<i class="fas fa-clipboard-list"></i> Lista de productos',
      items: [
        {
          text: 'Productos',
          active: true,
        },
      ],
      products: [],
      tableHeaders: [
        { key: 'reference', label: 'Referencia' },
        { key: 'name', label: 'Nombre' },
        { key: 'extension', label: 'Extensión' },
        { key: 'serial', label: 'Serial' },
        { key: 'lote', label: 'Lote' },
        { key: 'due_date', label: 'Vencimiento' },
        { key: 'warehouse_name', label: 'Bodega' },
        { key: 'ubication_name', label: 'Ubicación' },
      ],
    }
  },
  methods: {
    ...productsMethods,
    myProvider(ctx) {
      let context = this
      const promise = context.fetchProducts(this.$table_params(ctx))
      return promise
        .then(response => {return response.data})
        .then((data) => {
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          console.log(error)
          return []
        })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-12 col-lg-12 px-xs-0 mx-xs-0">
        <ProductsTable
          ref="table"
          class="products_table"
          :tableheaders="tableHeaders"
          :drfprovider="myProvider"
        >
          <template v-slot:cell(extension)="data">
            {{ data.item.ext_description }} {{ data.item.ext_detail }}
          </template>
        </ProductsTable>
      </div>
    </div>
  </Layout>
</template>